import { render } from "./EditAssetPage.vue?vue&type=template&id=16dacd54&scoped=true"
import script from "./EditAssetPage.vue?vue&type=script&lang=js"
export * from "./EditAssetPage.vue?vue&type=script&lang=js"

import "./EditAssetPage.vue?vue&type=style&index=0&id=16dacd54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16dacd54"]])

export default __exports__